import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import MesComponent from './MesComponent';
import { filtrarVisitasMesAno } from '../../../redux/DucksUnidadInspeccion/CalendarioDuck'
import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import estilos from './Calendario.module.css'
import {
    faAngleLeft, faAngleRight
} from '@fortawesome/free-solid-svg-icons'
import CalendarioSemanalComponent from './CalendarioSemanalComponent';

import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import { actualizarInspector, obtenerDiasByIdZona } from '../../../redux/DucksUnidadInspeccion/MesZonaDuck';
import { getInspectorById, getInspectores, obtenerInspectorByIdLogin } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck';
import { Cancel, Edit, Save } from '@mui/icons-material';
import { getSolicitudByIdInspector, updateSolicitud } from '../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';

import moment from 'moment'
import 'moment/locale/es'
import { getClienteByNumsocio } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import { host } from '../../../configuraciones';

library.add(faAngleLeft, faAngleRight)

function Calendario(props) {

    const dispatch = useDispatch()

    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0]
    const currentUser = useSelector(store => store.Usuario.data)

    const zona = props.zona
    const inspectores = useSelector(store => store.Inspectores.inspectores)

    const [visitasMesActual, setVisitasMesActual] = useState([]);
    //const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    const [solicitudes, setSolicitudes] = useState([]);
    const calendario = useSelector(store => store.MesZona.semanas)
    const [showCalendarioMensual, setShowCalendarioMensual] = React.useState(true);
    const [zonaActual, setZonaActual] = React.useState(1);
    const [urlPDF, setUrlPDF] = React.useState('');
    const [isEditandoInspector, setisEditandoInspector] = React.useState(false)
    const [isEditandoInspectorTemporal, setisEditandoInspectorTemporal] = React.useState(false)
    const [inspectorSeleccionado, setinspectorSeleccionado] = React.useState(null)
    const [inspectorTemporalSeleccionado, setinspectorTemporalSeleccionado] = React.useState(null)

    const [periodosOrdenados, setPeriodosOrdenados] = React.useState([])

    let periodo = []
    const anios = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035]
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    const initPeriodos = () => {
        let acumulador = 0;
        for (let index = 0; index < anios.length; index++) {
            for (let x = 1; x <= 12; x++) {
                periodo.push(getDaysArray(anios[index], x, acumulador))
                acumulador++;
            }
        }
    }

    const getDaysArray = (year, month, acumulador) => {

        var monthIndex = month - 1;
        var numberOfDay = [0, 1, 2, 3, 4, 5, 6];
        var date = new Date(year, monthIndex, 1);
        var result = [];
        let aux = [
            { id: acumulador, numeroDeMes: month, mes: meses[monthIndex], dias: new Date(year, month, 0).getDate(), empieza: numberOfDay[date.getDay()], ano: date.getFullYear() }
        ]
        result.push(aux)
        return result;
    }

    initPeriodos()

    const [mesActual, setMesActual] = React.useState(periodo[100][0]);

    const mesAnterior = () => {
        if (periodo[mesActual[0].id] != undefined || mesActual[0].id == 0) {
            setMesActual(periodo[mesActual[0].id - 1][0])
            props.actualizarDias(zona)
        }
    }

    const mesSiguiente = () => {
        if (periodo[mesActual[0].id] != undefined || mesActual[0].id == 0) {
            setMesActual(periodo[mesActual[0].id + 1][0])
            props.actualizarDias(zona)
        }
    }

    React.useEffect(() => {
        //BUSCAR SEMANAS POR IDZONA
        zona != null ? dispatch(obtenerDiasByIdZona(zona?.idzona)) : 1
    }, [zona])

    const obtenerSolicitudes = () => {
        let idinspector = periodosOrdenados[mesActual[0].numeroDeMes - 1]?.idinspector != undefined ? periodosOrdenados[mesActual[0].numeroDeMes - 1].idinspector : 1;
        dispatch(getSolicitudByIdInspector(idinspector)).then((res) => {
            setSolicitudes(res.payload.data.data)
        })
    }

    React.useEffect(() => {
        //dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        //obtenerSolicitudes()
        dispatch(filtrarVisitasMesAno({ mes: mesActual[0].mes, ano: mesActual[0].ano }))
    }, [mesActual])

    React.useEffect(() => {
        let idinspector = periodosOrdenados[mesActual[0].numeroDeMes - 1]?.idinspector != undefined ? periodosOrdenados[mesActual[0].numeroDeMes - 1].idinspector : 1;
        dispatch(getSolicitudByIdInspector(idinspector)).then((res) => {
            setSolicitudes(res.payload.data.data)
        })
    }, [periodosOrdenados])

    React.useEffect(() => {
        let solicitudespormes = []
        if (solicitudes != undefined) {
            if (solicitudes.length > 0) {
                solicitudes.forEach(solicitud => {
                    let fecha = new Date(solicitud.fecharealdeinspeccion)
                    if (meses[fecha.getMonth()] === mesActual[0].mes) {
                        solicitudespormes.push(solicitud)
                    }

                });
            }
        }
        setVisitasMesActual(solicitudespormes)
    }, [solicitudes])

    React.useEffect(() => {
        visitasMesActual
    }, [visitasMesActual])

    React.useEffect(() => {
        calendario
    }, [calendario])

    const handleShowCalendarioMensual = () => {
        setShowCalendarioMensual(true)
        setShowCalendarioSemanal(false)
    }

    const handleShowCalendarioSemanal = () => {
        setShowCalendarioMensual(false)
        setShowCalendarioSemanal(true)
    }

    React.useEffect(() => {
        dispatch(getInspectores());
    }, [])


    React.useEffect(() => {
        inspectores
    }, [inspectores])

    function compararPorEdad(a, b) {
        return a.idperiodozona - b.idperiodozona;
    }

    const ordenarPeriodos = () => {
        let array = []
        zona &&
            zona.meszona.forEach((m) => {
                array.push(m)
            })
        setPeriodosOrdenados(array.sort(compararPorEdad))
    }

    React.useEffect(() => {
        let array = []
        zona &&
            zona.meszona.forEach((m) => {
                array.push(m)
            })
        setPeriodosOrdenados(array.sort(compararPorEdad))
    }, [zona, mesActual])

    const handleActualizarInspector = async (periodoinspector) => {
        if (isNaN(inspectorSeleccionado) || inspectorSeleccionado == null) {
        } else {
            await dispatch(actualizarLoadingApp_true())

            const data = {
                data: {
                    idmeszona: periodoinspector.idmeszona,
                    idinspector: Number(inspectorSeleccionado)
                }
            }
            dispatch(actualizarInspector(data)).then(async (res) => {
                if (visitasMesActual.length > 0) {
                    visitasMesActual.forEach((visita) => {
                        if (visita.statusdelasolicitud === 1) {
                            let fecha = new Date();
                            const data = {
                                data: {
                                    idsolicitudesuifc01: visita.fc_01_solicitudderegistro.solicitudesuifc01[0].idsolicitudesuifc01,
                                    idinspector: Number(inspectorSeleccionado),
                                    idfc01_solicitudregistro: Number(visita.idfc01_solicitudregistro),
                                    fecharealdeinspeccion: visita.fecharealdeinspeccion,
                                    asignadopor: visita.asignadopor,
                                    statusdelasolicitud: visita.statusdelasolicitud,
                                    folioui: visita.folioui,
                                    ncomision: visita.ncomision
                                }
                            }
                            dispatch(updateSolicitud(data)).then((res) => {
                                dispatch(getClienteByNumsocio(visita.fc_01_solicitudderegistro.numerosocio)).then(async (a) => {
                                    dispatch(getInspectorById(inspectorSeleccionado)).then(async (response) => {
                                        dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then(async (gerente) => {

                                            let nombre = "";
                                            inspectores.forEach((e) => {
                                                if (e.login != null) {
                                                    if (e.login.idlogin === idUsuario.id) {
                                                        nombre = e.nombre + " " + e.apellidos
                                                    }
                                                }
                                            })

                                            let nombreIns = "";

                                            inspectores.forEach((e) => {
                                                if (e.idinspector === Number(inspectorSeleccionado)) {
                                                    nombreIns = e.nombre + " " + e.apellidos
                                                }
                                            })

                                            let nombreInspector;
                                            let apellidosInspector;
                                            nombreInspector = response.payload.data.data.nombre.split(" ")
                                            apellidosInspector = response.payload.data.data.apellidos.split(" ")

                                            let nombreArchivo = "FI01-";

                                            const fecha = Date.now();
                                            const hoy = new Date(fecha);

                                            let anio = hoy.getFullYear();
                                            let mes = hoy.getMonth() + 1;
                                            let dia = hoy.getDate();

                                            dia = ('0' + dia).slice(-2);
                                            mes = ('0' + mes).slice(-2);

                                            let anios = String(anio)
                                            let fechaForm = dia + "" + mes + "" + anios[2] + anios[3];
                                            let fechaForm2 = dia + "/" + mes + "/" + anios[2] + anios[3];
                                            let inicialesInspector = "";

                                            for (let i = 0; i < nombreInspector.length; i++) {
                                                inicialesInspector += nombreInspector[i][0]
                                            }

                                            for (let i = 0; i < apellidosInspector.length; i++) {
                                                inicialesInspector += apellidosInspector[i][0]
                                            }

                                            nombreArchivo += visita.fc_01_solicitudderegistro.numerosocio + "-" + visita.ncomision + "." + anios[2] + anios[3] + fechaForm + inicialesInspector + ".pdf"

                                            let nombregerente = gerente.payload.data.data.titulo + ". " + gerente.payload.data.data.nombre + " " + gerente.payload.data.data.apellidos

                                            const data = {
                                                numeroDeEscritoComision: visita.ncomision,
                                                fecha: fechaForm2,
                                                nombreDelCliente: visita.fc_01_solicitudderegistro.nombrerazonsocial,
                                                domicilioDelInstalacion: visita.fc_01_solicitudderegistro.calle + " " + visita.fc_01_solicitudderegistro.numeroexterior + " " + visita.fc_01_solicitudderegistro.municipioalcaldia + " " + visita.fc_01_solicitudderegistro.estado,
                                                telefono: visita.fc_01_solicitudderegistro.telefono,
                                                nombreInspector: nombreIns,
                                                idsolicitudesuifc01: visita.fc_01_solicitudderegistro.solicitudesuifc01[0].idsolicitudesuifc01,
                                                idcliente: a.payload.data.data.idcliente,
                                                nombreArchivo: nombreArchivo,
                                                reasignar: true,
                                                nombregerente: nombregerente,
                                                idinspector: Number(gerente.payload.data.data.idinspector),
                                            };

                                            const documento = await fetch(host + 'ArchivosUnidadInspeccion/actualizarEscritoDeComision', {
                                                method: 'POST',
                                                mode: 'cors',
                                                body: JSON.stringify(data),
                                                headers: new Headers({
                                                    'Content-Type': 'application/json',
                                                    'Access-Control-Allow-Origin': '*',
                                                }),
                                            })

                                            if (documento.status != 404) {
                                                const blob = await documento.blob();
                                                const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                                //window.open(url);
                                                setUrlPDF(url)
                                                let a = document.createElement("a");
                                                a.href = url;
                                                a.download = nombreArchivo;
                                                a.click()

                                                await dispatch(actualizarLoadingApp_false())
                                            } else {
                                                console.log("aqui error")
                                            }
                                        })
                                    })
                                })
                            })
                        }

                    })
                }
                await dispatch(actualizarLoadingApp_false())
                props.actualizarZonas()
                setisEditandoInspector(!isEditandoInspector)
                ordenarPeriodos()
            })
        }
    }

    const handleInspectorTemporal = (meszona) => {

        if (inspectorTemporalSeleccionado != null) {

            let nombretemporal = ""

            let ins = inspectores.filter(x => x.idinspector == inspectorTemporalSeleccionado)
            nombretemporal = ins[0].titulo + ". " + ins[0].nombre + " " + ins[0].apellidos

            const data = {
                data: {
                    idmeszona: meszona.idmeszona,
                    inspectortemporal: nombretemporal
                }
            }
            dispatch(actualizarInspector(data))
            props.actualizarZonas()
            setisEditandoInspector(!isEditandoInspector)
            setisEditandoInspectorTemporal(false)
            ordenarPeriodos()
        }
    }

    return (
        <Fragment><br />
            {
                showCalendarioMensual ? (
                    <div>
                        <div className='row text-center'>
                            <div className='col-md-4 mt-4'>
                                <button className={`badge bg-primary text-light ${estilos.escalar}`} onClick={mesAnterior}><FontAwesomeIcon icon={faAngleLeft} /><br />mes anterior</button>
                            </div>
                            {
                                zona &&
                                <div className='col-md-4'>
                                    <h2>Mes de <strong>{mesActual[0].mes}</strong></h2>
                                    {periodosOrdenados.length > 0 ?
                                        <Fragment>
                                            <h5>Periodo Actual: (  {periodosOrdenados[mesActual[0].numeroDeMes - 1]?.idperiodozona < 10 ? ("P0" + periodosOrdenados[mesActual[0].numeroDeMes - 1]?.idperiodozona) : ("P" + periodosOrdenados[mesActual[0].numeroDeMes - 1]?.idperiodozona)} ) del {mesActual[0].ano}</h5>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <div className="row-md-4 mt-4">
                                                {
                                                    isEditandoInspector ?
                                                        <div>
                                                            <select name="select" className="form-select" onChange={(e) => setinspectorSeleccionado(e.target.value)}>
                                                                <option value="A" selected>Seleccione un Inspector</option>
                                                                {inspectores.map((i, index) => (
                                                                    <option key={index} value={i.idinspector}>{i.titulo}. {i.nombre} {i.apellidos}</option>
                                                                ))}

                                                            </select>
                                                            <br />
                                                        </div>
                                                        :
                                                        <h5>Inspector: {zona.meszona[mesActual[0].numeroDeMes - 1]?.inspector?.titulo}. {zona.meszona[mesActual[0].numeroDeMes - 1]?.inspector?.nombre} {zona.meszona[mesActual[0].numeroDeMes - 1]?.inspector?.apellidos}</h5>
                                                }
                                                <button className={isEditandoInspector ? "btn btn-sm btn-success" : "btn btn-sm btn-warning"} onClick={() => { isEditandoInspector ? handleActualizarInspector(zona.meszona[mesActual[0].numeroDeMes - 1]) : setisEditandoInspector(!isEditandoInspector) }}>{isEditandoInspector ? "Guardar" : "Reasignar"}</button>
                                            </div>
                                        </Fragment>
                                    }
                                </div>
                            }
                            <div className='col-md-4 mt-4'>
                                <button className={`badge bg-primary text-light ${estilos.escalar}`} onClick={mesSiguiente}><FontAwesomeIcon icon={faAngleRight} /><br />mes siguiente</button>
                            </div>
                        </div>
                        <div>
                            <h6 style={{ wordWrap: "break-word", textAlign: "center" }}>Del {moment.utc(periodosOrdenados[mesActual[0].numeroDeMes - 1]?.periodozona.fechainicio).format("LL")} al {moment.utc(periodosOrdenados[mesActual[0].numeroDeMes - 1]?.periodozona.fechafin).format("LL")}</h6>
                            <div className="row-md-4 mt-4">
                                {
                                    isEditandoInspector ?
                                        <div className='row'>
                                            <div className="row" style={{ textAlign: "center" }}><h6>Seleccione un Inspector para el periodo de esta zona</h6></div>
                                            <div className="col-md-3"></div>
                                            <div className="col-md-5">
                                                <select name="select" className="form-select" onChange={(e) => setinspectorSeleccionado(e.target.value)}>
                                                    <option value="A" selected>Seleccione un Inspector</option>
                                                    {inspectores.map((i, index) => (
                                                        <option key={index} value={i.idinspector}>{i.titulo}. {i.nombre} {i.apellidos}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <button className={isEditandoInspector ? "btn btn-sm btn-success" : "btn btn-sm btn-warning"} data-toggle="tooltip" data-placement="top" title={isEditandoInspector ? "Guardar" : "Reasignar"} onClick={() => { isEditandoInspector ? handleActualizarInspector(periodosOrdenados[mesActual[0].numeroDeMes - 1]) : setisEditandoInspector(!isEditandoInspector) }}>{isEditandoInspector ? <Save></Save> : <Edit></Edit>}</button>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                    {
                                                        isEditandoInspector ?
                                                            <div className="col-md-2">
                                                                <button className="btn btn-sm btn-danger" data-toggle="tooltip" data-placement="top" title="Cancelar" onClick={() => { setinspectorSeleccionado(null); setisEditandoInspector(!isEditandoInspector); setisEditandoInspectorTemporal(false); }}><Cancel></Cancel></button>
                                                            </div>
                                                            :
                                                            <Fragment></Fragment>
                                                    }
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                        :
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-5">
                                                <h6 style={{ textAlign: "right" }}>Inspector: {periodosOrdenados[mesActual[0].numeroDeMes - 1]?.inspector.titulo}. {periodosOrdenados[mesActual[0].numeroDeMes - 1]?.inspector.nombre} {periodosOrdenados[mesActual[0].numeroDeMes - 1]?.inspector.apellidos}</h6>
                                            </div>
                                            <div className="col-md-2" style={{ textAlign: "left !important" }}>
                                                <button className={isEditandoInspector ? "btn btn-sm btn-success" : "btn btn-sm btn-warning"} data-toggle="tooltip" data-placement="top" title={isEditandoInspector ? "Guardar" : "Reasignar"} onClick={() => { isEditandoInspector ? handleActualizarInspector(periodosOrdenados[mesActual[0].numeroDeMes - 1]) : setisEditandoInspector(!isEditandoInspector) }}>{isEditandoInspector ? <Save></Save> : <Edit></Edit>}</button>
                                            </div>
                                        </div>

                                }
                                {
                                    isEditandoInspector === false ?
                                        periodosOrdenados[mesActual[0].numeroDeMes - 1]?.inspectortemporal != null ?
                                            <div style={{ textAlign: "center" }}>
                                                <br />
                                                <h6>Inspector Temporal: {periodosOrdenados[mesActual[0].numeroDeMes - 1]?.inspectortemporal}</h6>
                                            </div>
                                            :
                                            <Fragment></Fragment>
                                        :
                                        <Fragment></Fragment>
                                }
                                <br />
                                {

                                    isEditandoInspector ?
                                        isEditandoInspectorTemporal ?
                                            <div className='row'>
                                                <div className="row" style={{ textAlign: "center" }}>
                                                    <h6>Seleccione un Inspector Temporal para el periodo de esta zona</h6>
                                                </div>
                                                <div className="col-md-3"></div>
                                                <div className="col-md-5">
                                                    <select name="select" className="form-select" onChange={(e) => setinspectorTemporalSeleccionado(e.target.value)}>
                                                        <option value="A" selected>Seleccione un Inspector Temporal</option>
                                                        {inspectores.map((i, index) => (
                                                            <option key={index} value={i.idinspector}>{i.titulo}. {i.nombre} {i.apellidos}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <button className={"btn btn-sm btn-success"} data-toggle="tooltip" data-placement="top" title={"Guardar"} onClick={() => { handleInspectorTemporal(periodosOrdenados[mesActual[0].numeroDeMes - 1]) }}>{<Save></Save>}</button>
                                                        </div>
                                                        <div className="col-md-2"></div>
                                                        {
                                                            isEditandoInspector ?
                                                                <div className="col-md-2">
                                                                    <button className="btn btn-sm btn-danger" data-toggle="tooltip" data-placement="top" title="Cancelar" onClick={() => { setisEditandoInspectorTemporal(false); }}><Cancel></Cancel></button>
                                                                </div>
                                                                :
                                                                <Fragment></Fragment>
                                                        }
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            :
                                            <div style={{ textAlign: "center" }}>
                                                <button className='btn btn-warning' onClick={() => { setisEditandoInspectorTemporal(true) }}>AGREGAR INSPECTOR TEMPORAL</button>
                                            </div>
                                        :
                                        <Fragment></Fragment>



                                }
                            </div>
                        </div>
                        <br /><br />

                        <MesComponent
                            ano={mesActual[0].ano}
                            visitasMes={visitasMesActual}
                            handleModal={props.handleModal}
                            key={mesActual[0].numeroDeMes}
                            mes={mesActual[0].mes}
                            numeroDeMes={mesActual[0].numeroDeMes}
                            dias={mesActual[0].dias - 1}
                            empieza={mesActual[0].empieza + 1}
                            semanas={calendario}
                            zona={zona}
                        >
                        </MesComponent>
                    </div>
                ) : (
                    <CalendarioSemanalComponent />
                )
            }

            <br />
        </Fragment>
    );
};


export default withRouter(Calendario)
